var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoPartager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45,40.6c-2.8,0-5.2,1.3-6.9,3.1l-10.9-7.5c0.6-1.3,1.2-2.8,1.2-4.2c0-1.4-0.4-2.9-1-4.2l10.8-7.4c1.6,1.8,4,3.1,6.8,3.1 c5,0,9.3-4.2,9.3-9.3S49.9,4.9,45,4.9s-9.3,4.2-9.3,9.3c0,1.6,0.4,3.1,1.2,4.4L26,26.1c-1.6-2-4.2-3.1-6.9-3.1c-5,0-9.3,4.2-9.3,9.3 s4.2,9.1,9.3,9.1c2.8,0,5.2-1.2,6.9-3.1l10.9,7.5c-0.6,1.3-1,2.8-1,4.2c0,5,4.2,9.3,9.3,9.3s9.3-4.2,9.3-9.3S49.9,40.6,45,40.6z  M45,7.2c3.9,0,6.9,3.1,6.9,6.9S48.8,21,45,21S38,18,38,14.1S41,7.2,45,7.2z M19.1,38.9c-3.9,0-6.9-3.1-6.9-6.9 c0-3.9,3.1-6.9,6.9-6.9S26,28.1,26,32S22.9,38.9,19.1,38.9z M45,56.8c-3.9,0-6.9-3.1-6.9-6.9s3-7,6.9-7s6.9,3.1,6.9,6.9 S48.8,56.8,45,56.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPartager);
export default __webpack_public_path__ + "static/media/picto-partager.55c6920afb03b4301acab92f477fed92.svg";
export { ForwardRef as ReactComponent };